module.exports = __webpack_public_path__ + "img/eTranzact Logo.47578ea7.png";